import axios from 'axios';
import {
  getErrorData,
  type IGenericResponseRoot,
  CANCEL_CODE
} from '../utils/getErrorData';
import { type IManagerUser } from '../types/IManagerAuth';

const API_ENDPOINT = `${import.meta.env.VITE_API_URL}/api/public/manager-auth`;

/**
 * Универсальный метод авторизации менеджера
 * @param email - email менеджера
 * @param code - код подтверждения (если не передан, то это первый шаг)
 * @param abortController - для отмены запроса
 * @returns Если код не передан - объект с message, если передан - данные пользователя
 */
export const managerAuth = async <T = { message: string } | IManagerUser>(
  email: string,
  code?: string,
  abortController?: AbortController
): Promise<IGenericResponseRoot<T> | undefined> => {
  try {
    const payload = code !== undefined ? { email, code } : { email };

    const response = await axios.post<IGenericResponseRoot<T>>(
      API_ENDPOINT,
      payload,
      {
        headers: { 'Content-Type': 'application/json' },
        signal: abortController?.signal
      }
    );

    return response.data;
  } catch (err) {
    const error = getErrorData(err);
    if (error.code === CANCEL_CODE) {
      return undefined;
    }
    // eslint-disable-next-line no-console
    console.error('managerAuth error', error.message);
    throw err;
  }
};
